export class FullFileDisclosureIdentity
{
    SocialSecurityNumber: string;
    ScreeningId: number;
    FirstName: string;
    LastName: string;
    DateOfBirth: Date;
}